module.exports = __webpack_public_path__ + "static/media/download-svmeet.b0262a85.png";